import { useEffect, useState } from "react";
import { Download, Search } from "lucide-react";
import { toast } from "sonner";
import api, { API } from "@/lib/api";
import { formatDate } from "@/lib/utils-format";
import { Btn, Toggle } from "@/components/admin/AdminUI";

const INTERESTS = ["Escapadas", "Gastronomía", "Tecnología", "Entretenimiento", "Moda", "Bienestar", "Protagonistas", "Diseño y Arquitectura", "Autos", "Profesión"];

export default function SubscribersAdmin() {
  const [subs, setSubs] = useState([]);
  const [search, setSearch] = useState("");
  const [interest, setInterest] = useState("");

  const load = () => {
    let url = "/admin/subscribers?";
    if (search) url += `search=${encodeURIComponent(search)}&`;
    if (interest) url += `interest=${encodeURIComponent(interest)}`;
    api.get(url).then((r) => setSubs(r.data || [])).catch(() => {});
  };
  useEffect(load, [search, interest]);

  const toggle = async (id) => { await api.put(`/admin/subscribers/${id}/toggle`); load(); };

  const exportCsv = async () => {
    try {
      const token = localStorage.getItem("sunset_token");
      const res = await fetch(`${API}/admin/subscribers/export`, { headers: { Authorization: `Bearer ${token}` } });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = "suscriptores.csv"; a.click();
      URL.revokeObjectURL(url);
      toast.success("CSV exportado");
    } catch { toast.error("Error al exportar"); }
  };

  return (
    <div>
      <header className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl tracking-tight">Suscriptores</h1>
          <p className="text-sunset-muted text-sm mt-1">{subs.length} suscriptores</p>
        </div>
        <Btn variant="accent" onClick={exportCsv} data-testid="export-csv-btn"><Download size={15} /> Exportar CSV</Btn>
      </header>

      <div className="flex flex-wrap gap-3 mb-6">
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-sunset-muted" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar por nombre o email…"
            className="bg-white border border-sunset-border pl-9 pr-3 py-2 text-sm focus:outline-none focus:border-sunset-accent w-72" />
        </div>
        <select value={interest} onChange={(e) => setInterest(e.target.value)}
          className="bg-white border border-sunset-border px-3 py-2 text-sm focus:outline-none focus:border-sunset-accent">
          <option value="">Todos los intereses</option>
          {INTERESTS.map((i) => <option key={i} value={i}>{i}</option>)}
        </select>
      </div>

      <div className="bg-white border border-sunset-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-sunset-border text-left text-xs uppercase tracking-wider text-sunset-muted">
              <th className="px-5 py-3">Nombre</th><th className="px-5 py-3">Email</th>
              <th className="px-5 py-3">Intereses</th><th className="px-5 py-3">Fecha</th><th className="px-5 py-3">Activo</th>
            </tr>
          </thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id} className="border-b border-sunset-border/60 hover:bg-sunset-bg" data-testid={`subscriber-row-${s.id}`}>
                <td className="px-5 py-4 font-medium">{s.first_name} {s.last_name}</td>
                <td className="px-5 py-4 text-sunset-muted">{s.email}</td>
                <td className="px-5 py-4"><div className="flex flex-wrap gap-1">{(s.interests || []).map((i) => <span key={i} className="text-[10px] bg-sunset-bg border border-sunset-border px-2 py-0.5">{i}</span>)}</div></td>
                <td className="px-5 py-4 text-sunset-muted">{formatDate(s.created_at)}</td>
                <td className="px-5 py-4"><Toggle checked={s.active} onChange={() => toggle(s.id)} /></td>
              </tr>
            ))}
            {subs.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-sunset-muted">No hay suscriptores.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
